import React from "react";
import { IconType } from "./types";

const CheckCircle: IconType = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="#006AAC"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M8 0.5C12.1338 0.5 15.5 3.86622 15.5 8C15.5 12.1338 12.1338 15.5 8 15.5C3.86622 15.5 0.5 12.1338 0.5 8C0.5 3.86622 3.86622 0.5 8 0.5ZM8 1.4375C4.38075 1.4375 1.4375 4.38075 1.4375 8C1.4375 11.6193 4.38075 14.5625 8 14.5625C11.6193 14.5625 14.5625 11.6193 14.5625 8C14.5625 4.38075 11.6193 1.4375 8 1.4375ZM11.6563 5L12.3125 5.65625L6.6875 11.2813L4.0625 8.65625L4.71875 8L6.6875 9.96875L11.6563 5Z"
      fill="inherit"
    />
  </svg>
);

export default CheckCircle;
